// Ease the use of universal server/browser functionality
// taken from https://github.com/TrilonIO/ng-universal/blob/master/libraries/ng-universal/src/lib/services/platform.service.ts

import { PlatformLocation, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { DOCUMENT, Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PlatformService {
    constructor(
        @Inject(PLATFORM_ID) private platformId: Record<string, unknown>,
        @Inject(DOCUMENT) private doc: Document,
        public platformLocation: PlatformLocation
    ) {}

    public get document() {
        return this.doc;
    }

    public get isBrowser(): boolean {
        return isPlatformBrowser(this.platformId);
    }

    public get isServer(): boolean {
        return isPlatformServer(this.platformId);
    }

    public get isPrerender(): boolean {
        return !this.platformLocation.hostname;
    }
}
